const wims_meta = [
    // {
    //   "stid": "VOOR",
    //   "number": 3,
    //   "name": "Voorheesville",
    //   "WIMS name": "VOORHEESVILLE",
    //   "lat [degrees]": 42.65242,
    //   "lon [degrees]": -73.97562,
    //   "elevation [m]": 115.062,
    //   "county": "Albany",
    //   "WIMS ID": 300012,
    //   "nearest_city": "Voorheesville",
    //   "state": "NY",
    //   "distance_from_town [km]": 3.8,
    //   "direction_from_town [degrees]": "W",
    //   "climate_division": 5,
    //   "climate_division_name": "Hudson Valley",
    //   "wfo": "ALY",
    //   "commissioned": "2016-08-16 16:10:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Albany Pine Bush",
    //   "RAWS ID": 300011
    // },
    // {
    //   "stid": "BELM",
    //   "number": 70,
    //   "name": "Belmont",
    //   "WIMS name": "BELMONT",
    //   "lat [degrees]": 42.24249,
    //   "lon [degrees]": -78.03958,
    //   "elevation [m]": 417.576,
    //   "county": "Allegany",
    //   "WIMS ID": 300031,
    //   "nearest_city": "Belmont",
    //   "state": "NY",
    //   "distance_from_town [km]": 2.2,
    //   "direction_from_town [degrees]": "N",
    //   "climate_division": 1,
    //   "climate_division_name": "Western Plateau",
    //   "wfo": "BUF",
    //   "commissioned": "2016-05-16 20:45:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Gang Mills",
    //   "RAWS ID": 301011
    // },
    // {
    //   "stid": "RAND",
    //   "number": 125,
    //   "name": "Randolph",
    //   "WIMS name": "RANDOLPH",
    //   "lat [degrees]": 42.14928,
    //   "lon [degrees]": -78.90096,
    //   "elevation [m]": 448.97,
    //   "county": "Cattaraugus",
    //   "WIMS ID": 300091,
    //   "nearest_city": "Randolph",
    //   "state": "NY",
    //   "distance_from_town [km]": 6.3,
    //   "direction_from_town [degrees]": "ESE",
    //   "climate_division": 1,
    //   "climate_division_name": "Western Plateau",
    //   "wfo": "BUF",
    //   "commissioned": "2016-06-02 15:50:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Gang Mills",
    //   "RAWS ID": 301011
    // },
    // {
    //   "stid": "SHER",
    //   "number": 54,
    //   "name": "Sherburne",
    //   "WIMS name": "SHERBURNE",
    //   "lat [degrees]": 42.64026,
    //   "lon [degrees]": -75.4837,
    //   "elevation [m]": 352.623,
    //   "county": "Chenango",
    //   "WIMS ID": 300172,
    //   "nearest_city": "Sherburne",
    //   "state": "NY",
    //   "distance_from_town [km]": 4.3,
    //   "direction_from_town [degrees]": "SSE",
    //   "climate_division": 2,
    //   "climate_division_name": "Eastern Plateau",
    //   "wfo": "BGM",
    //   "commissioned": "2016-02-23 19:05:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Sherburne",
    //   "RAWS ID": 300171
    // },
    // {
    //   "stid": "CHAZ",
    //   "number": 29,
    //   "name": "Chazy",
    //   "WIMS name": "CHAZY",
    //   "lat [degrees]": 44.89565,
    //   "lon [degrees]": -73.46461,
    //   "elevation [m]": 56.571,
    //   "county": "Clinton",
    //   "WIMS ID": 300192,
    //   "nearest_city": "Chazy",
    //   "state": "NY",
    //   "distance_from_town [km]": 2.4,
    //   "direction_from_town [degrees]": "WNW",
    //   "climate_division": 7,
    //   "climate_division_name": "Champlain Valley",
    //   "wfo": "BTV",
    //   "commissioned": "2016-07-08 17:40:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Schuyler Falls",
    //   "RAWS ID": 300191
    // },
    // {
    //   "stid": "SARA",
    //   "number": 121,
    //   "name": "Saranac",
    //   "WIMS name": "SARANAC",
    //   "lat [degrees]": 44.707585,
    //   "lon [degrees]": -73.67115,
    //   "elevation [m]": 313.731,
    //   "county": "Clinton",
    //   "WIMS ID": 300193,
    //   "nearest_city": "Saranac",
    //   "state": "NY",
    //   "distance_from_town [km]": 8.5,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 7,
    //   "climate_division_name": "Champlain Valley",
    //   "wfo": "BTV",
    //   "commissioned": "2016-07-12 18:10:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Schuyler Falls",
    //   "RAWS ID": 300191
    // },
    // {
    //   "stid": "COPA",
    //   "number": 57,
    //   "name": "Copake",
    //   "WIMS name": "COPAKE",
    //   "lat [degrees]": 42.13659,
    //   "lon [degrees]": -73.51988,
    //   "elevation [m]": 208.849,
    //   "county": "Columbia",
    //   "WIMS ID": 300211,
    //   "nearest_city": "Copake",
    //   "state": "NY",
    //   "distance_from_town [km]": 4.4,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 5,
    //   "climate_division_name": "Hudson Valley",
    //   "wfo": "ALY",
    //   "commissioned": "2016-08-03 18:10:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Albany Pine Bush",
    //   "RAWS ID": 300011
    // },
    // {
    //   "stid": "WALT",
    //   "number": 95,
    //   "name": "Walton",
    //   "WIMS name": "WALTON",
    //   "lat [degrees]": 42.2395,
    //   "lon [degrees]": -75.17879,
    //   "elevation [m]": 559.796,
    //   "county": "Delaware",
    //   "WIMS ID": 300251,
    //   "nearest_city": "Walton",
    //   "state": "NY",
    //   "distance_from_town [km]": 8.8,
    //   "direction_from_town [degrees]": "NNW",
    //   "climate_division": 2,
    //   "climate_division_name": "Eastern Plateau",
    //   "wfo": "BGM",
    //   "commissioned": "2016-04-18 19:05:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Sherburne",
    //   "RAWS ID": 300171
    // },
    // {
    //   "stid": "BUFF",
    //   "number": 4,
    //   "name": "Buffalo",
    //   "WIMS name": "BUFFALO",
    //   "lat [degrees]": 43.00017,
    //   "lon [degrees]": -78.76717,
    //   "elevation [m]": 179.588,
    //   "county": "Erie",
    //   "WIMS ID": 300291,
    //   "nearest_city": "Buffalo",
    //   "state": "NY",
    //   "distance_from_town [km]": 15.6,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 9,
    //   "climate_division_name": "Great Lakes",
    //   "wfo": "BUF",
    //   "commissioned": "2017-03-09 21:20:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lowville",
    //   "RAWS ID": 300491
    // },
    // {
    //   "stid": "ESSX",
    //   "number": 13,
    //   "name": "Essex",
    //   "WIMS name": "ESSEX",
    //   "lat [degrees]": 44.313604,
    //   "lon [degrees]": -73.371896,
    //   "elevation [m]": 55.5,
    //   "county": "Essex",
    //   "WIMS ID": 300313,
    //   "nearest_city": "Essex",
    //   "state": "NY",
    //   "distance_from_town [km]": 1.6,
    //   "direction_from_town [degrees]": "WNW",
    //   "climate_division": 7,
    //   "climate_division_name": "Champlain Valley",
    //   "wfo": "BTV",
    //   "commissioned": "2015-12-05 21:15:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Schuyler Falls",
    //   "RAWS ID": 300191
    // },
    // {
    //   "stid": "NEWC",
    //   "number": 48,
    //   "name": "Newcomb",
    //   "WIMS name": "NEWCOMB",
    //   "lat [degrees]": 43.97329,
    //   "lon [degrees]": -74.22273,
    //   "elevation [m]": 501.396,
    //   "county": "Essex",
    //   "WIMS ID": 300314,
    //   "nearest_city": "Newcomb",
    //   "state": "NY",
    //   "distance_from_town [km]": 4.7,
    //   "direction_from_town [degrees]": "W",
    //   "climate_division": 3,
    //   "climate_division_name": "Northern Plateau",
    //   "wfo": "BTV",
    //   "commissioned": "2016-10-18 16:45:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Mt Van Hoevenberg",
    //   "RAWS ID": 300312
    // },
    // {
    //   "stid": "WFMB",
    //   "number": 14,
    //   "name": "Whiteface Mountain Base",
    //   "WIMS name": "WHITEFACE MOUNTAIN",
    //   "lat [degrees]": 44.393236,
    //   "lon [degrees]": -73.858829,
    //   "elevation [m]": 614.599,
    //   "county": "Essex",
    //   "WIMS ID": 300315,
    //   "nearest_city": "Wilmington",
    //   "state": "NY",
    //   "distance_from_town [km]": 3.5,
    //   "direction_from_town [degrees]": "W",
    //   "climate_division": 7,
    //   "climate_division_name": "Champlain Valley",
    //   "wfo": "BTV",
    //   "commissioned": "2016-01-29 20:55:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Mt Van Hoevenberg",
    //   "RAWS ID": 300312
    // },
    // {
    //   "stid": "GABR",
    //   "number": 118,
    //   "name": "Gabriels",
    //   "WIMS name": "GABRIELS",
    //   "lat [degrees]": 44.41742,
    //   "lon [degrees]": -74.17867,
    //   "elevation [m]": 535.72,
    //   "county": "Franklin",
    //   "WIMS ID": 300331,
    //   "nearest_city": "Gabriels",
    //   "state": "NY",
    //   "distance_from_town [km]": 1.6,
    //   "direction_from_town [degrees]": "S",
    //   "climate_division": 3,
    //   "climate_division_name": "Northern Plateau",
    //   "wfo": "BTV",
    //   "commissioned": "2016-01-20 20:15:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Wanakena",
    //   "RAWS ID": 300891
    // },
    // {
    //   "stid": "MALO",
    //   "number": 21,
    //   "name": "Malone",
    //   "WIMS name": "MALONE",
    //   "lat [degrees]": 44.852869,
    //   "lon [degrees]": -74.328874,
    //   "elevation [m]": 236.22,
    //   "county": "Franklin",
    //   "WIMS ID": 300332,
    //   "nearest_city": "Malone",
    //   "state": "NY",
    //   "distance_from_town [km]": 2.7,
    //   "direction_from_town [degrees]": "W",
    //   "climate_division": 8,
    //   "climate_division_name": "St. Lawrence Valley",
    //   "wfo": "BTV",
    //   "commissioned": "2016-08-15 22:30:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Brasher Falls",
    //   "RAWS ID": 300892
    // },
    // {
    //   "stid": "TUPP",
    //   "number": 124,
    //   "name": "Tupper Lake",
    //   "WIMS name": "TUPPER LAKE",
    //   "lat [degrees]": 44.22128,
    //   "lon [degrees]": -74.43826,
    //   "elevation [m]": 502.829,
    //   "county": "Franklin",
    //   "WIMS ID": 300333,
    //   "nearest_city": "Tupper Lake",
    //   "state": "NY",
    //   "distance_from_town [km]": 2.1,
    //   "direction_from_town [degrees]": "E",
    //   "climate_division": 3,
    //   "climate_division_name": "Northern Plateau",
    //   "wfo": "BTV",
    //   "commissioned": "2016-07-13 17:20:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Wanakena",
    //   "RAWS ID": 300891
    // },
    // {
    //   "stid": "TANN",
    //   "number": 108,
    //   "name": "Tannersville",
    //   "WIMS name": "TANNERSVILLE",
    //   "lat [degrees]": 42.17071,
    //   "lon [degrees]": -74.11343,
    //   "elevation [m]": 711.373,
    //   "county": "Greene",
    //   "WIMS ID": 300391,
    //   "nearest_city": "Tannersville",
    //   "state": "NY",
    //   "distance_from_town [km]": 3.3,
    //   "direction_from_town [degrees]": "SSE",
    //   "climate_division": 2,
    //   "climate_division_name": "Eastern Plateau",
    //   "wfo": "ALY",
    //   "commissioned": "2017-02-01 20:30:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Catskill Center",
    //   "RAWS ID": 301111
    // },
    // {
    //   "stid": "ILAK",
    //   "number": 122,
    //   "name": "Indian Lake",
    //   "WIMS name": "INDIAN LAKE",
    //   "lat [degrees]": 43.79067,
    //   "lon [degrees]": -74.23933,
    //   "elevation [m]": 494.172,
    //   "county": "Hamilton",
    //   "WIMS ID": 300412,
    //   "nearest_city": "Indian Lake",
    //   "state": "NY",
    //   "distance_from_town [km]": 2.3,
    //   "direction_from_town [degrees]": "ENE",
    //   "climate_division": 3,
    //   "climate_division_name": "Northern Plateau",
    //   "wfo": "ALY",
    //   "commissioned": "2016-07-26 16:25:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lake Pleasant",
    //   "RAWS ID": 300411
    // },
    // {
    //   "stid": "PISE",
    //   "number": 114,
    //   "name": "Piseco",
    //   "WIMS name": "PISECO",
    //   "lat [degrees]": 43.46474,
    //   "lon [degrees]": -74.50432,
    //   "elevation [m]": 535.991,
    //   "county": "Hamilton",
    //   "WIMS ID": 300413,
    //   "nearest_city": "Piseco",
    //   "state": "NY",
    //   "distance_from_town [km]": 3.1,
    //   "direction_from_town [degrees]": "NNE",
    //   "climate_division": 3,
    //   "climate_division_name": "Northern Plateau",
    //   "wfo": "ALY",
    //   "commissioned": "2017-03-25 16:00:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lake Pleasant",
    //   "RAWS ID": 300411
    // },
    // {
    //   "stid": "RAQU",
    //   "number": 45,
    //   "name": "Raquette Lake",
    //   "WIMS name": "RAQUETTE LAKE",
    //   "lat [degrees]": 43.822752,
    //   "lon [degrees]": -74.625091,
    //   "elevation [m]": 539.74,
    //   "county": "Hamilton",
    //   "WIMS ID": 300414,
    //   "nearest_city": "Raquette Lake",
    //   "state": "NY",
    //   "distance_from_town [km]": 2.8,
    //   "direction_from_town [degrees]": "ENE",
    //   "climate_division": 3,
    //   "climate_division_name": "Northern Plateau",
    //   "wfo": "ALY",
    //   "commissioned": "2016-11-10 18:55:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lake Pleasant",
    //   "RAWS ID": 300411
    // },
    // {
    //   "stid": "COLD",
    //   "number": 32,
    //   "name": "Cold Brook",
    //   "WIMS name": "COLD BROOK",
    //   "lat [degrees]": 43.261268,
    //   "lon [degrees]": -74.978778,
    //   "elevation [m]": 433.395,
    //   "county": "Herkimer",
    //   "WIMS ID": 300431,
    //   "nearest_city": "Cold Brook",
    //   "state": "NY",
    //   "distance_from_town [km]": 5.4,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 6,
    //   "climate_division_name": "Mohawk Valley",
    //   "wfo": "ALY",
    //   "commissioned": "2015-11-11 20:55:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lake Pleasant",
    //   "RAWS ID": 300411
    // },
    // {
    //   "stid": "OLDF",
    //   "number": 11,
    //   "name": "Old Forge",
    //   "WIMS name": "OLD FORGE",
    //   "lat [degrees]": 43.74157,
    //   "lon [degrees]": -74.97786,
    //   "elevation [m]": 534.406,
    //   "county": "Herkimer",
    //   "WIMS ID": 300432,
    //   "nearest_city": "Old Forge",
    //   "state": "NY",
    //   "distance_from_town [km]": 3.5,
    //   "direction_from_town [degrees]": "N",
    //   "climate_division": 3,
    //   "climate_division_name": "Northern Plateau",
    //   "wfo": "ALY",
    //   "commissioned": "2016-09-02 15:25:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lake Pleasant",
    //   "RAWS ID": 300411
    // },
    // {
    //   "stid": "PHIL",
    //   "number": 89,
    //   "name": "Philadelphia",
    //   "WIMS name": "PHILADELPHIA",
    //   "lat [degrees]": 44.19354,
    //   "lon [degrees]": -75.71591,
    //   "elevation [m]": 130.912,
    //   "county": "Jefferson",
    //   "WIMS ID": 300451,
    //   "nearest_city": "Philadelphia",
    //   "state": "NY",
    //   "distance_from_town [km]": 4.3,
    //   "direction_from_town [degrees]": "N",
    //   "climate_division": 9,
    //   "climate_division_name": "Great Lakes",
    //   "wfo": "BUF",
    //   "commissioned": "2016-07-08 00:05:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Brasher Falls",
    //   "RAWS ID": 300892
    // },
    // {
    //   "stid": "COPE",
    //   "number": 93,
    //   "name": "Copenhagen",
    //   "WIMS name": "COPENHAGEN",
    //   "lat [degrees]": 43.920564,
    //   "lon [degrees]": -75.607866,
    //   "elevation [m]": 249.113,
    //   "county": "Lewis",
    //   "WIMS ID": 300492,
    //   "nearest_city": "Carthage",
    //   "state": "NY",
    //   "distance_from_town [km]": 6.4,
    //   "direction_from_town [degrees]": "S",
    //   "climate_division": 3,
    //   "climate_division_name": "Northern Plateau",
    //   "wfo": "BUF",
    //   "commissioned": "2016-02-05 19:10:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lowville",
    //   "RAWS ID": 300491
    // },
    // {
    //   "stid": "RUSH",
    //   "number": 87,
    //   "name": "Rush",
    //   "WIMS name": "RUSH",
    //   "lat [degrees]": 43.00099,
    //   "lon [degrees]": -77.63739,
    //   "elevation [m]": 180.807,
    //   "county": "Monroe",
    //   "WIMS ID": 300551,
    //   "nearest_city": "Rush",
    //   "state": "NY",
    //   "distance_from_town [km]": 0.8,
    //   "direction_from_town [degrees]": "NW",
    //   "climate_division": 9,
    //   "climate_division_name": "Great Lakes",
    //   "wfo": "BUF",
    //   "commissioned": "2016-07-12 18:20:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lowville",
    //   "RAWS ID": 300491
    // },
    // {
    //   "stid": "WANT",
    //   "number": 42,
    //   "name": "Wantagh",
    //   "WIMS name": "WANTAGH",
    //   "lat [degrees]": 40.6551,
    //   "lon [degrees]": -73.50616,
    //   "elevation [m]": 8.5344,
    //   "county": "Nassau",
    //   "WIMS ID": 300591,
    //   "nearest_city": "Wantagh",
    //   "state": "NY",
    //   "distance_from_town [km]": 3.2,
    //   "direction_from_town [degrees]": "S",
    //   "climate_division": 4,
    //   "climate_division_name": "Coastal",
    //   "wfo": "OKX",
    //   "commissioned": "2016-11-10 03:05:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Gang Mills",
    //   "RAWS ID": 301011
    // },
    // {
    //   "stid": "JORD",
    //   "number": 27,
    //   "name": "Jordan",
    //   "WIMS name": "JORDAN",
    //   "lat [degrees]": 43.0698,
    //   "lon [degrees]": -76.47006,
    //   "elevation [m]": 122.682,
    //   "county": "Onondaga",
    //   "WIMS ID": 300671,
    //   "nearest_city": "Jordan",
    //   "state": "NY",
    //   "distance_from_town [km]": 0.5,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 10,
    //   "climate_division_name": "Central Lakes",
    //   "wfo": "BGM",
    //   "commissioned": "2015-11-17 21:45:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lowville",
    //   "RAWS ID": 300491
    // },
    // {
    //   "stid": "TULL",
    //   "number": 83,
    //   "name": "Tully",
    //   "WIMS name": "TULLY",
    //   "lat [degrees]": 42.79463,
    //   "lon [degrees]": -76.11555,
    //   "elevation [m]": 378.379,
    //   "county": "Onondaga",
    //   "WIMS ID": 300672,
    //   "nearest_city": "Tully",
    //   "state": "NY",
    //   "distance_from_town [km]": 0.6,
    //   "direction_from_town [degrees]": "SW",
    //   "climate_division": 10,
    //   "climate_division_name": "Central Lakes",
    //   "wfo": "BGM",
    //   "commissioned": "2016-03-30 17:30:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Sherburne",
    //   "RAWS ID": 300171
    // },
    // {
    //   "stid": "SBRI",
    //   "number": 75,
    //   "name": "South Bristol",
    //   "WIMS name": "SOUTH BRISTOL",
    //   "lat [degrees]": 42.75217,
    //   "lon [degrees]": -77.35931,
    //   "elevation [m]": 349.64,
    //   "county": "Ontario",
    //   "WIMS ID": 300691,
    //   "nearest_city": "South Bristol",
    //   "state": "NY",
    //   "distance_from_town [km]": 4.1,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 10,
    //   "climate_division_name": "Central Lakes",
    //   "wfo": "BUF",
    //   "commissioned": "2016-02-19 01:25:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Gang Mills",
    //   "RAWS ID": 301011
    // },
    // {
    //   "stid": "OTIS",
    //   "number": 100,
    //   "name": "Otisville",
    //   "WIMS name": "OTISVILLE",
    //   "lat [degrees]": 41.48249,
    //   "lon [degrees]": -74.50368,
    //   "elevation [m]": 237.165,
    //   "county": "Orange",
    //   "WIMS ID": 300711,
    //   "nearest_city": "Otisville",
    //   "state": "NY",
    //   "distance_from_town [km]": 3.1,
    //   "direction_from_town [degrees]": "E",
    //   "climate_division": 2,
    //   "climate_division_name": "Eastern Plateau",
    //   "wfo": "OKX",
    //   "commissioned": "2015-12-10 18:20:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Stony Kill",
    //   "RAWS ID": 305103
    // },
    // {
    //   "stid": "CSQR",
    //   "number": 85,
    //   "name": "Central Square",
    //   "WIMS name": "CENTRAL SQUARE",
    //   "lat [degrees]": 43.32613,
    //   "lon [degrees]": -76.10445,
    //   "elevation [m]": 138.01,
    //   "county": "Oswego",
    //   "WIMS ID": 300751,
    //   "nearest_city": "Central Square",
    //   "state": "NY",
    //   "distance_from_town [km]": 5.5,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 9,
    //   "climate_division_name": "Great Lakes",
    //   "wfo": "BUF",
    //   "commissioned": "2015-11-05 01:00:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Lowville",
    //   "RAWS ID": 300491
    // },
    // {
    //   "stid": "BREW",
    //   "number": 109,
    //   "name": "Brewster",
    //   "WIMS name": "BREWSTER",
    //   "lat [degrees]": 41.43993,
    //   "lon [degrees]": -73.57642,
    //   "elevation [m]": 185.349,
    //   "county": "Putnam",
    //   "WIMS ID": 300791,
    //   "nearest_city": "Brewster",
    //   "state": "NY",
    //   "distance_from_town [km]": 5.8,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 5,
    //   "climate_division_name": "Hudson Valley",
    //   "wfo": "OKX",
    //   "commissioned": "2017-03-30 22:15:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Stony Kill",
    //   "RAWS ID": 305103
    // },
    // {
    //   "stid": "STAT",
    //   "number": 20,
    //   "name": "Staten Island",
    //   "WIMS name": "STATEN ISLAND",
    //   "lat [degrees]": 40.604014,
    //   "lon [degrees]": -74.148499,
    //   "elevation [m]": 33.1,
    //   "county": "Richmond",
    //   "WIMS ID": 300851,
    //   "nearest_city": "Staten Island",
    //   "state": "NY",
    //   "distance_from_town [km]": 5.3,
    //   "direction_from_town [degrees]": "N",
    //   "climate_division": 4,
    //   "climate_division_name": "Coastal",
    //   "wfo": "OKX",
    //   "commissioned": "2017-05-03 22:15:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Gang Mills",
    //   "RAWS ID": 301011
    // },
    // {
    //   "stid": "EDWA",
    //   "number": 17,
    //   "name": "Edwards",
    //   "WIMS name": "EDWARDS",
    //   "lat [degrees]": 44.32177,
    //   "lon [degrees]": -75.24413,
    //   "elevation [m]": 207.996,
    //   "county": "St. Lawrence",
    //   "WIMS ID": 300893,
    //   "nearest_city": "Edwards",
    //   "state": "NY",
    //   "distance_from_town [km]": 0.6,
    //   "direction_from_town [degrees]": "ESE",
    //   "climate_division": 8,
    //   "climate_division_name": "St. Lawrence Valley",
    //   "wfo": "BTV",
    //   "commissioned": "2016-08-16 23:10:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Brasher Falls",
    //   "RAWS ID": 300892
    // },
    // {
    //   "stid": "HAMM",
    //   "number": 60,
    //   "name": "Hammond",
    //   "WIMS name": "HAMMOND",
    //   "lat [degrees]": 44.51302,
    //   "lon [degrees]": -75.61729,
    //   "elevation [m]": 111.953,
    //   "county": "St. Lawrence",
    //   "WIMS ID": 300894,
    //   "nearest_city": "Hammond",
    //   "state": "NY",
    //   "distance_from_town [km]": 9.4,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 8,
    //   "climate_division_name": "St. Lawrence Valley",
    //   "wfo": "BTV",
    //   "commissioned": "2016-08-16 16:50:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Brasher Falls",
    //   "RAWS ID": 300892
    // },
    // {
    //   "stid": "LOUI",
    //   "number": 61,
    //   "name": "Louisville",
    //   "WIMS name": "LOUISVILLE",
    //   "lat [degrees]": 44.87169,
    //   "lon [degrees]": -75.05608,
    //   "elevation [m]": 85.1002,
    //   "county": "St. Lawrence",
    //   "WIMS ID": 300895,
    //   "nearest_city": "Louisville",
    //   "state": "NY",
    //   "distance_from_town [km]": 4.2,
    //   "direction_from_town [degrees]": "SW",
    //   "climate_division": 8,
    //   "climate_division_name": "St. Lawrence Valley",
    //   "wfo": "BTV",
    //   "commissioned": "2016-03-26 19:20:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Brasher Falls",
    //   "RAWS ID": 300892
    // },
    // {
    //   "stid": "EDIN",
    //   "number": 49,
    //   "name": "Edinburg",
    //   "WIMS name": "EDINBURG",
    //   "lat [degrees]": 43.22819,
    //   "lon [degrees]": -74.11293,
    //   "elevation [m]": 324.703,
    //   "county": "Saratoga",
    //   "WIMS ID": 300911,
    //   "nearest_city": "Edinburg",
    //   "state": "NY",
    //   "distance_from_town [km]": 1,
    //   "direction_from_town [degrees]": "NW",
    //   "climate_division": 6,
    //   "climate_division_name": "Mohawk Valley",
    //   "wfo": "ALY",
    //   "commissioned": "2016-07-15 20:15:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Schroon Lake",
    //   "RAWS ID": 300311
    // },
    // {
    //   "stid": "SCHU",
    //   "number": 9,
    //   "name": "Schuylerville",
    //   "WIMS name": "SCHUYLERVILLE",
    //   "lat [degrees]": 43.116996,
    //   "lon [degrees]": -73.578284,
    //   "elevation [m]": 31.4462,
    //   "county": "Saratoga",
    //   "WIMS ID": 300912,
    //   "nearest_city": "Schuylerville",
    //   "state": "NY",
    //   "distance_from_town [km]": 1.9,
    //   "direction_from_town [degrees]": "N",
    //   "climate_division": 5,
    //   "climate_division_name": "Hudson Valley",
    //   "wfo": "ALY",
    //   "commissioned": "2015-08-09 20:40:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Schroon Lake",
    //   "RAWS ID": 300311
    // },
    // {
    //   "stid": "COBL",
    //   "number": 23,
    //   "name": "Cobleskill",
    //   "WIMS name": "COBLESKILL",
    //   "lat [degrees]": 42.676267,
    //   "lon [degrees]": -74.507967,
    //   "elevation [m]": 327.96,
    //   "county": "Schoharie",
    //   "WIMS ID": 300951,
    //   "nearest_city": "Cobleskill",
    //   "state": "NY",
    //   "distance_from_town [km]": 1.9,
    //   "direction_from_town [degrees]": "W",
    //   "climate_division": 2,
    //   "climate_division_name": "Eastern Plateau",
    //   "wfo": "ALY",
    //   "commissioned": "2016-01-25 23:05:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Sherburne",
    //   "RAWS ID": 300171
    // },
    // {
    //   "stid": "BURD",
    //   "number": 78,
    //   "name": "Burdett",
    //   "WIMS name": "BURDETT",
    //   "lat [degrees]": 42.41042,
    //   "lon [degrees]": -76.77176,
    //   "elevation [m]": 567.751,
    //   "county": "Schuyler",
    //   "WIMS ID": 300972,
    //   "nearest_city": "Burdett",
    //   "state": "NY",
    //   "distance_from_town [km]": 6.5,
    //   "direction_from_town [degrees]": "E",
    //   "climate_division": 10,
    //   "climate_division_name": "Central Lakes",
    //   "wfo": "BGM",
    //   "commissioned": "2016-05-23 15:05:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Gang Mills",
    //   "RAWS ID": 301011
    // },
    // {
    //   "stid": "ADDI",
    //   "number": 107,
    //   "name": "Addison",
    //   "WIMS name": "ADDISON",
    //   "lat [degrees]": 42.04036,
    //   "lon [degrees]": -77.23726,
    //   "elevation [m]": 507.614,
    //   "county": "Steuben",
    //   "WIMS ID": 301012,
    //   "nearest_city": "Addison",
    //   "state": "NY",
    //   "distance_from_town [km]": 6.9,
    //   "direction_from_town [degrees]": "S",
    //   "climate_division": 1,
    //   "climate_division_name": "Western Plateau",
    //   "wfo": "BGM",
    //   "commissioned": "2016-08-10 18:15:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Gang Mills",
    //   "RAWS ID": 301011
    // },
    // {
    //   "stid": "SOUT",
    //   "number": 35,
    //   "name": "Southold",
    //   "WIMS name": "SOUTHOLD",
    //   "lat [degrees]": 41.040081,
    //   "lon [degrees]": -72.465864,
    //   "elevation [m]": 8.93064,
    //   "county": "Suffolk",
    //   "WIMS ID": 301031,
    //   "nearest_city": "Southold",
    //   "state": "NY",
    //   "distance_from_town [km]": 4.3,
    //   "direction_from_town [degrees]": "SW",
    //   "climate_division": 4,
    //   "climate_division_name": "Coastal",
    //   "wfo": "OKX",
    //   "commissioned": "2016-11-10 22:25:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Gang Mills",
    //   "RAWS ID": 301011
    // },
    // {
    //   "stid": "STON",
    //   "number": 2,
    //   "name": "Stony Brook",
    //   "WIMS name": "STONY BROOK",
    //   "lat [degrees]": 40.91912,
    //   "lon [degrees]": -73.13168,
    //   "elevation [m]": 43.9217,
    //   "county": "Suffolk",
    //   "WIMS ID": 301032,
    //   "nearest_city": "Stony Brook",
    //   "state": "NY",
    //   "distance_from_town [km]": 1.06,
    //   "direction_from_town [degrees]": "SE",
    //   "climate_division": 4,
    //   "climate_division_name": "Coastal",
    //   "wfo": "OKX",
    //   "commissioned": "2018-02-21 15:35:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Gang Mills",
    //   "RAWS ID": 301011
    // },
    // {
    //   "stid": "ELDR",
    //   "number": 53,
    //   "name": "Eldred",
    //   "WIMS name": "ELDRED",
    //   "lat [degrees]": 41.53961,
    //   "lon [degrees]": -74.87992,
    //   "elevation [m]": 347.624,
    //   "county": "Sullivan",
    //   "WIMS ID": 301051,
    //   "nearest_city": "Eldred",
    //   "state": "NY",
    //   "distance_from_town [km]": 1.4,
    //   "direction_from_town [degrees]": "NNE",
    //   "climate_division": 2,
    //   "climate_division_name": "Eastern Plateau",
    //   "wfo": "BGM",
    //   "commissioned": "2016-08-25 17:15:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Stony Kill",
    //   "RAWS ID": 305103
    // },
    // {
    //   "stid": "OWEG",
    //   "number": 52,
    //   "name": "Owego",
    //   "WIMS name": "OWEGO",
    //   "lat [degrees]": 42.02571,
    //   "lon [degrees]": -76.25543,
    //   "elevation [m]": 447.873,
    //   "county": "Tioga",
    //   "WIMS ID": 301071,
    //   "nearest_city": "Owego",
    //   "state": "NY",
    //   "distance_from_town [km]": 8.5,
    //   "direction_from_town [degrees]": "S",
    //   "climate_division": 2,
    //   "climate_division_name": "Eastern Plateau",
    //   "wfo": "BGM",
    //   "commissioned": "2016-07-20 22:35:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Sherburne",
    //   "RAWS ID": 300171
    // },
    // {
    //   "stid": "CLAR",
    //   "number": 110,
    //   "name": "Claryville",
    //   "WIMS name": "CLARYVILLE",
    //   "lat [degrees]": 41.9792,
    //   "lon [degrees]": -74.5171,
    //   "elevation [m]": 583.692,
    //   "county": "Ulster",
    //   "WIMS ID": 301112,
    //   "nearest_city": "Claryville",
    //   "state": "NY",
    //   "distance_from_town [km]": 8.2,
    //   "direction_from_town [degrees]": "NE",
    //   "climate_division": 2,
    //   "climate_division_name": "Eastern Plateau",
    //   "wfo": "BGM",
    //   "commissioned": "2016-10-20 19:00:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Catskill Center",
    //   "RAWS ID": 301111
    // },
    // {
    //   "stid": "HFAL",
    //   "number": 82,
    //   "name": "High Falls",
    //   "WIMS name": "HIGH FALLS",
    //   "lat [degrees]": 41.7988,
    //   "lon [degrees]": -74.12312,
    //   "elevation [m]": 193.121,
    //   "county": "Ulster",
    //   "WIMS ID": 301113,
    //   "nearest_city": "High Falls",
    //   "state": "NY",
    //   "distance_from_town [km]": 3.1,
    //   "direction_from_town [degrees]": "S",
    //   "climate_division": 5,
    //   "climate_division_name": "Hudson Valley",
    //   "wfo": "ALY",
    //   "commissioned": "2016-11-17 18:25:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Stony Kill",
    //   "RAWS ID": 305103
    // },
    // {
    //   "stid": "CHES",
    //   "number": 18,
    //   "name": "Chestertown",
    //   "WIMS name": "CHESTERTOWN",
    //   "lat [degrees]": 43.6539,
    //   "lon [degrees]": -73.77736,
    //   "elevation [m]": 332.02,
    //   "county": "Warren",
    //   "WIMS ID": 301131,
    //   "nearest_city": "Chestertown",
    //   "state": "NY",
    //   "distance_from_town [km]": 1.9,
    //   "direction_from_town [degrees]": "E",
    //   "climate_division": 7,
    //   "climate_division_name": "Champlain Valley",
    //   "wfo": "ALY",
    //   "commissioned": "2015-12-06 21:45:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Schroon Lake",
    //   "RAWS ID": 300311
    // },
    // {
    //   "stid": "WHIT",
    //   "number": 10,
    //   "name": "Whitehall",
    //   "WIMS name": "WHITEHALL",
    //   "lat [degrees]": 43.485073,
    //   "lon [degrees]": -73.423071,
    //   "elevation [m]": 36.5638,
    //   "county": "Washington",
    //   "WIMS ID": 301151,
    //   "nearest_city": "Whitehall",
    //   "state": "NY",
    //   "distance_from_town [km]": 8,
    //   "direction_from_town [degrees]": "S",
    //   "climate_division": 7,
    //   "climate_division_name": "Champlain Valley",
    //   "wfo": "ALY",
    //   "commissioned": "2015-08-26 20:30:00 UTC",
    //   "decommissioned": "",
    //   "In WIMS": "Y",
    //   "RAWS station": "Schroon Lake",
    //   "RAWS ID": 300311
    // },
    // Hudson Valley Stns
    {
      "stid": "BEAC",
      "name": "Beacon",
      "WIMS name": "Beacon",
      "lat [degrees]": 41.52875,
      "lon [degrees]": -73.94527,
    },
    {
      "stid": "SOME",
      "name": "Somers",
      "WIMS name": "Somers",
      "lat [degrees]": 41.31037,
      "lon [degrees]": -73.76711,
    },
    {
      "stid": "TANN",
      "name": "Tannersville",
      "WIMS name": "Tannersville",
      "lat [degrees]": 42.17071,
      "lon [degrees]": -74.11343,
    },
    {
      "stid": "VOOR",
      "name": "Voorheesville",
      "WIMS name": "Voorheesville",
      "lat [degrees]": 42.65242,
      "lon [degrees]": -73.97562,
    },
    {
      "stid": "SCHO",
      "name": "Schodack",
      "WIMS name": "Schodack",
      "lat [degrees]": 42.50631,
      "lon [degrees]": -73.68584,
    },
    {
      "stid": "KIND",
      "name": "Kinderhook",
      "WIMS name": "Kinderhook",
      "lat [degrees]": 42.41001,
      "lon [degrees]": -73.71557,
    },
    {
      "stid": "SUFF",
      "name": "Suffern",
      "WIMS name": "Suffern",
      "lat [degrees]": 41.13038,
      "lon [degrees]": -74.08987,
    },
    {
      "stid": "OTIS",
      "name": "Otisville",
      "WIMS name": "Otisville",
      "lat [degrees]": 41.48249,
      "lon [degrees]": -74.50368,
    },
    {
      "stid": "ROXB",
      "name": "Roxbury",
      "WIMS name": "Roxbury",
      "lat [degrees]": 42.32964,
      "lon [degrees]": -74.46746,
    },
    {
      "stid": "REDH",
      "name": "Red Hook",
      "WIMS name": "Red Hook",
      "lat [degrees]": 42.00168,
      "lon [degrees]": -73.88391,
    },
    {
      "stid": "CLAR",
      "name": "Claryville",
      "WIMS name": "Claryville",
      "lat [degrees]": 41.9792,
      "lon [degrees]": -74.5171,
    },
    {
      "stid": "STEP",
      "name": "Stephentown",
      "WIMS name": "Stephentown",
      "lat [degrees]": 42.5262,
      "lon [degrees]": -73.35906,
    },
    {
      "stid": "HFAL",
      "name": "High Falls",
      "WIMS name": "High Falls",
      "lat [degrees]": 41.7988,
      "lon [degrees]": -74.12312,
    },
    {
      "stid": "WBOU",
      "name": "Woodbourne",
      "WIMS name": "Woodbourne",
      "lat [degrees]": 41.74505,
      "lon [degrees]": -74.58833,
    },
    {
      "stid": "WALL",
      "name": "Wallkill",
      "WIMS name": "Wallkill",
      "lat [degrees]": 41.63409,
      "lon [degrees]": -74.1537,
    },
    {
      "stid": "DOVE",
      "name": "Dover Plains",
      "WIMS name": "Dover Plains",
      "lat [degrees]": 41.77367,
      "lon [degrees]": -73.57542,
    },
    {
      "stid": "COPA",
      "name": "Copake",
      "WIMS name": "Copake",
      "lat [degrees]": 42.13659,
      "lon [degrees]": -73.51988,
    },
    {
      "stid": "BREW",
      "name": "Brewster",
      "WIMS name": "Brewster",
      "lat [degrees]": 41.43993,
      "lon [degrees]": -73.57642,
    },
    {
      "stid": "MEDU",
      "name": "Medusa",
      "WIMS name": "Medusa",
      "lat [degrees]": 42.46869,
      "lon [degrees]": -74.16541,
    },
    {
      "stid": "ELDR",
      "name": "Eldred",
      "WIMS name": "Eldred",
      "lat [degrees]": 41.539610,
      "lon [degrees]": -74.879920,
    },
    {
      "stid": "NBRA",
      "name": "North Branch",
      "WIMS name": "North Branch",
      "lat [degrees]": 41.827920,
      "lon [degrees]": -74.996890,
    },
    {
      "stid": "HARP",
      "name": "Harpersfield",
      "WIMS name": "Harpersfield",
      "lat [degrees]": 42.472800,
      "lon [degrees]": -74.698490,
    },
    {
      "stid": "DUAN",
      "name": "Duanesburg",
      "WIMS name": "Duanesburg",
      "lat [degrees]": 42.803190,
      "lon [degrees]": -74.173610,
    },
    {
      "stid": "COBL",
      "name": "Cobleskill",
      "WIMS name": "Cobleskill",
      "lat [degrees]": 42.676267,
      "lon [degrees]": -74.507967,
    },
    {
      "stid": "ANDE",
      "name": "Andes",
      "WIMS name": "Andes",
      "lat [degrees]": 42.182270,
      "lon [degrees]": -74.801390,
    },
  ]

export { wims_meta };